import { HttpClient } from "../helpers/HttpClient";

export const getStatements = async () => {
    return await HttpClient({
        url: `/v2/acceptable_statements`,
        method: "get",
    });
};

export const postAcceptStatement = async (acceptable_statement_id: number) => {
    return await HttpClient({
        url: `/v2/acceptable_statements/accept`,
        method: "post",
        data: { acceptable_statement_id },
    });
};
//  {
//      "user_id": 1,
//      "acceptable_statement_id": 1
//  }
